import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PanAppState } from '@panamax/app-state';
import { Observable, of } from 'rxjs';
import { PageTitle } from 'src/app/shared/constants/page-titles.enum';

@Injectable({
  providedIn: 'root',
})
export class ProductDetailResolverService {
  constructor(
    private panAppState: PanAppState,
    private router: Router,
    private translateService: TranslateService,
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<number> {
    this.panAppState.setPageTitle(
      this.translateService.instant(PageTitle.productDetail),
    );

    if (!this.isNumber(route)) {
      this.router.navigate(['/desktop/404']);
      return of(0);
    }
    this.getProductNumberFromRoute(route);
    return of(this.getProductNumberFromRoute(route));
  }

  getProductNumberFromRoute(route: ActivatedRouteSnapshot): number {
    const productNumber = parseInt(route.paramMap.get('productId'), 10);
    return productNumber;
  }

  isNumber(route: ActivatedRouteSnapshot): boolean {
    return route.paramMap.get('productId').match(/^[0-9]+$/) !== null;
  }
}
